import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var ApiError = /*#__PURE__*/function (_Error) {
  function ApiError(message, errorAttributes) {
    var _this;
    _classCallCheck(this, ApiError);
    _this = _callSuper(this, ApiError, [message]);
    _this.message = message;
    _this.errorAttributes = errorAttributes;
    return _this;
  }
  _inherits(ApiError, _Error);
  return _createClass(ApiError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var isApiError = function isApiError(error) {
  return error instanceof ApiError;
};
export var mapErrorToApiError = function mapErrorToApiError(error) {
  if (isApiError(error)) {
    return error;
  }

  // Fallback since we expect the error to be an instance of ApiError
  return new ApiError(error.message, {
    statusCode: 0
  });
};